var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "button_hidden",
    "data-name": "button hidden",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button_hidden-2",
    "data-name": "button hidden",
    transform: "translate(747 -1520) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "button",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1520 717)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-up",
    d: "M2.031.328C2.463.75,6.688,5.185,6.688,5.185a1.132,1.132,0,0,1,0,1.63s-4.225,4.437-4.657,4.857a1.229,1.229,0,0,1-1.671,0,1.1,1.1,0,0,1,0-1.628L4.236,6,.36,1.958a1.1,1.1,0,0,1,0-1.63A1.228,1.228,0,0,1,2.031.328Z",
    transform: "translate(1538.035 737.5) rotate(180)",
    fill: "#888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButton);
export default __webpack_public_path__ + "static/media/arrow-button.d7061bdee09d9d5515119a0179d5d049.svg";
export { ForwardRef as ReactComponent };